module.exports = __webpack_public_path__ + "img/file-heart.95143deb.svg";